import React, { Component } from 'react';
import { Modal, Input, Icon, message } from 'antd';
import './EditPasswordModal.scss';

/**
 * EditPasswordModal Component
 * A modern Ant Design modal for password-protected redirections.
 * 
 * @param {Object} props
 * @param {boolean} props.visible - Modal visibility
 * @param {Function} props.onCancel - Close handler
 * @param {Function} props.onSuccess - Callback on correct password (optional)
 * @param {string} props.targetPath - Redirection path (e.g., '/Comercial/EditComercial')
 * @param {Object} props.history - React Router history object
 * @param {Object} props.passData - Data to pass in history.state
 */
class EditPasswordModal extends Component {
  state = {
    password: ''
  };

  handleOk = () => {
    const { password } = this.state;
    const { targetPath, history, passData, onCancel, onSuccess } = this.props;

    if (password === "pcpedit246.") {
      if (onSuccess) onSuccess();
      onCancel();
      history.push({
        pathname: targetPath,
        state: passData
      });
      this.setState({ password: '' });
    } else {
      message.error("Contraseña incorrecta, Vuelva intentarlo");
    }
  };

  render() {
    const { visible, onCancel } = this.props;
    const { password } = this.state;

    return (
      <Modal
        title={
          <div className="ant-modal-title-content">
            <Icon type="lock" style={{ marginRight: '10px' }} />
            ACCESO RESTRINGIDO
          </div>
        }
        visible={visible}
        onOk={this.handleOk}
        onCancel={onCancel}
        okText="Confirmar"
        cancelText="Cancelar"
        className="edit-password-modal"
        centered
        width={420}
      >
        <div style={{ padding: '0 8px' }}>
          <div style={{ 
            textAlign: 'center', 
            marginBottom: '24px',
            background: 'rgba(24, 144, 255, 0.05)',
            padding: '16px',
            borderRadius: '12px',
            border: '1px dashed rgba(24, 144, 255, 0.3)'
          }}>
            <p style={{ 
              margin: 0, 
              color: 'rgba(0, 0, 0, 0.65)',
              fontSize: '14px',
              lineHeight: '1.6'
            }}>
              Para proteger la integridad de los datos, <br/>
              es necesario ingresar la contraseña de seguridad.
            </p>
          </div>
          
          <div style={{ marginBottom: '8px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px', 
              fontWeight: '600',
              color: 'rgba(0,0,0,0.85)',
              fontSize: '12px',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}>
              Contraseña de Edición
            </label>
            <Input.Password
              prefix={<Icon type="safety" style={{ color: '#1890ff' }} />}
              placeholder="••••••••"
              name="password"
              className="password-input"
              value={password}
              onChange={(e) => this.setState({ password: e.target.value })}
              onPressEnter={this.handleOk}
              autoFocus
              size="large"
            />
          </div>
        </div>
      </Modal>
    );
  }
}

export default EditPasswordModal;
